import styled from "styled-components"
import colors from "~constants/colors"
import React from "react"
import { rgba } from "polished"

interface PortfolioProps {
  isFocused: boolean
  margin?: number
}

export const TouchableItem = styled.div<PortfolioProps>`
  display: flex;
  border: 1px solid ${colors.gray2};
  justify-content: flex-start;
  align-items: center;
  padding: 8px;
  cursor: pointer;
  margin-bottom: 10px;
  background-color: ${props =>
    props.isFocused ? ` ${colors.lightBlue2}` : `${colors.white}`};
  margin-right: ${props => (props.margin ? ` ${props.margin}` : 0)}px;
`

export const BrokerageStatementSection = styled.div`
  border-radius: 6px;
`

export const StatementLoader = styled.div`
  align-items: center;
  justify-content: center;
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: column;
`

export const Badge = styled.div`
  background-color: ${props => rgba(props.color, 0.1)};
  color: ${props => props.color};
  font-weight: bold;
  min-width: 90px;
  padding: 0 20px;
  border-radius: 15px;
`

export const statementContainer: React.CSSProperties = {
  marginLeft: 0,
  height: "75vh",
}

export const pooCreatePortfolio: React.CSSProperties = {
  display: "flex",
  flexDirection: "column",
  height: "75vh",
  overflowY: "auto",
  padding: 5,
  marginLeft: 8,
}
